// import { BASE_URL } from '@/api/url';
// import BaseFuncApi from '@/api/base/commonFunc-api';
// import Enum from '@/enum/enum';
import ShipperClient from '@/api/shipper/shipper-client';
const shipperClient = new ShipperClient();
export default {
}